import { render, staticRenderFns } from "./ViewTemplateForm.vue?vue&type=template&id=5ae232ba&scoped=true&"
import script from "./ViewTemplateForm.vue?vue&type=script&lang=ts&"
export * from "./ViewTemplateForm.vue?vue&type=script&lang=ts&"
import style0 from "./ViewTemplateForm.vue?vue&type=style&index=0&id=5ae232ba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae232ba",
  null
  
)

export default component.exports